export default {
  name: 'SettingsThemeColor',
  props: {
    color: {
      type: String,
      default: '',
      required: true
    },
    colors: {
      type: Array,
      default: () => [],
      required: true
    },
    customerColor: {
      type: String,
      default: () => '#44EB2C',
      required: false
    }
  },
  data() {
    return {
      currentColor: this.color,
      currentCustomerColor: this.customerColor
    };
  },
  watch: {
    color() {
      this.currentColor = this.color;
    },
    customerColor() {
      this.currentCustomerColor = this.customerColor;
    }
  },
  methods: {
    setColor(color) {
      this.currentColor = color;
      this.$emit('input', color);
    },
    setCustomColor(colorObj) {
      this.$emit('input:customer', colorObj.hex);
    }
  }
};